import { Link } from "react-router-dom";

const targets = [
  {
    icon: "ri-global-line",
    color: "bg-emerald-100 text-emerald-600",
    title: "本場の英語を身につけたい",
    points: [
      "ネイティブの英語が学べる環境",
      "非英語圏学生が少なくより没入できる",
      "語学学校の質が高いと評判",
    ],
  },
  {
    icon: "ri-wallet-3-line",
    color: "bg-amber-100 text-amber-600",
    title: "できるだけ費用を抑えたい",
    points: [
      "英語圏の中で物価が比較的安い",
      "ホームステイが充実",
      "エージェント手数料0円で安心",
    ],
  },
  {
    icon: "ri-compass-3-line",
    color: "bg-sky-100 text-sky-600",
    title: "ヨーロッパ旅行も楽しみたい",
    points: [
      "EU加盟国で旅行がしやすい",
      "格安LCCで各国へアクセス可",
      "ヨーロッパ文化に触れられる",
    ],
  },
  {
    icon: "ri-school-line",
    color: "bg-rose-100 text-rose-600",
    title: "高校生のうちに留学したい",
    points: [
      "アイルランドには高校留学プログラムあり",
      "現地高校に正式入学できる",
      "英語＆異文化体験が同時に叶う",
    ],
  },
];

export default function ForYouSection() {
  return (
    <section id="foryou" className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="text-emerald-600 text-sm font-semibold tracking-widest uppercase">For You</span>
          <h2 className="text-3xl font-bold text-gray-800 mt-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            🍀 こんなあなたに！！ 🍀
          </h2>
          <p className="text-emerald-700 font-semibold mt-3">
            アイルランド留学で夢を実現するClassLive留学の強み
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {targets.map((t, i) => (
            <div key={i} className="border border-gray-100 rounded-lg p-6 hover:border-emerald-200 transition-all">
              <div className="flex items-center gap-3 mb-4">
                <div className={`w-10 h-10 flex items-center justify-center rounded-full ${t.color}`}>
                  <i className={`${t.icon} text-lg`} />
                </div>
                <h3 className="font-bold text-gray-800">{t.title}</h3>
              </div>
              <ul className="space-y-2">
                {t.points.map((p, j) => (
                  <li key={j} className="flex items-start gap-2 text-sm text-gray-600">
                    <span className="w-4 h-4 flex items-center justify-center text-emerald-500 mt-0.5">
                      <i className="ri-check-line" />
                    </span>
                    {p}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-emerald-600 rounded-lg p-8 text-center text-white">
          <p className="text-lg font-bold mb-2">🌟 あなたに合った留学プランを一緒に考えます</p>
          <p className="text-emerald-100 text-sm mb-6">無料相談では、留学の目的・期間・予算に合わせて最適なプランをご提案します</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <div className="flex flex-col items-center gap-1">
              <p className="text-xs font-bold text-[#06C755]">
                <i className="ri-gift-line mr-1" />今なら特典もプレゼント!/
              </p>
              <a
                href="https://lstep.app/N5D3BZr"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-[#06C755] text-white font-bold px-8 py-3 rounded-full text-sm cursor-pointer hover:bg-[#05b34c] transition-colors whitespace-nowrap shadow-lg"
              >
                <i className="ri-line-line text-xl" />
                LINEで相談する
              </a>
            </div>
            <div className="flex flex-col items-center gap-1">
              <p className="text-xs font-bold text-emerald-200">
                <i className="ri-time-line mr-1" />簡単30秒!/
              </p>
              <Link
                to="/counseling"
                className="inline-flex items-center justify-center gap-2 bg-white text-emerald-700 font-bold px-8 py-3 rounded-full text-sm cursor-pointer hover:bg-emerald-50 transition-colors whitespace-nowrap shadow-lg"
              >
                <i className="ri-calendar-check-line text-xl" />
                無料カウンセリング予約
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
